import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { environment } from './environments/environment';
import { CanDeactivateGuard } from '@shared/guards/can-deactivate.guard';
import { AuthorizationGuard } from '@shared/authorization.guard';
import { AppInsightsService } from '@shared/services/app-insights.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppInsightsInterceptor } from '@shared/app-insights.interceptor';
import { ErrorInterceptor } from '@shared/error.interceptor';
import { NextGenMFAErrorInterceptor } from '@shared/nextgen-mfa-error.interceptor';
import { NextGenForcePasswordChangeErrorInterceptor } from '@shared/nextgen-force-password-change-error.interceptor';
import { ConfigHubAuthInterceptor } from './app/config-hub/shared/interceptors/auth.interceptor';
import { provideNgxMask } from 'ngx-mask';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { CoreModule } from '@shared/core.module';
import { BasicSharedModule } from '@shared/basic-shared.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { provideRouter } from '@angular/router';
import { routes } from './app/app.routes';
import { ModalModule } from 'ngx-bootstrap/modal';
import { InsightsModule } from './app/app-insights.module';
import { AppComponent } from './app/app.component';
import { LocatorService } from "shared/services/locator.service";
import { setLicenseKey } from "@mescius/wijmo";
import { provideHighcharts } from 'highcharts-angular';
import 'bootstrap';

const wijmoKey = sessionStorage.getItem('WijmoLicenseKey') ?? localStorage.getItem('client-portal.WijmoLicenseKey');
console.log('[Main] Wijmo prefix:', wijmoKey ? wijmoKey.substring(0, 20) : '(missing)');

setLicenseKey(wijmoKey);

export function getBaseUrl() {
    return document.getElementsByTagName('base')[0].href;
}

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection({eventCoalescing: true, runCoalescing: true}),
        provideToastr(),
        importProvidersFrom(BrowserModule, CoreModule, BasicSharedModule, ModalModule, InsightsModule),
        CanDeactivateGuard,
        AuthorizationGuard,
        AppInsightsService,
        provideHttpClient(withInterceptorsFromDi()),
        { provide: HTTP_INTERCEPTORS, useClass: AppInsightsInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: NextGenMFAErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: NextGenForcePasswordChangeErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ConfigHubAuthInterceptor, multi: true },
        provideNgxMask(),
        provideAnimations(), // deprecated but required until ngx-bootstrap removes their dependency. Not directly used by UN/FY
        provideRouter(routes),
        provideHighcharts({
        // Provide the Highcharts instance
            instance: () => import('highcharts/esm/highcharts.js').then(m => m.default),
        // Provide modules to be initialized with that instance
            modules: () => [
                import('highcharts/esm/modules/heatmap'),
                import('highcharts/esm/modules/no-data-to-display')
            ]
        })
    ]
})
    .then(appRef => {
        LocatorService.injector = appRef.injector;
    })
    .catch(err => console.log(err));
